export default {
  slug: "qodana",
  code: "QD",
  label: "Qodana",
  krakenDir: "Qodana",
  thumbnailColor: "#FC801D",
  logoFamily: "jb",
};
